var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttemptCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.20776C8.97064 1.20776 0 9.90754 0 20.6039C0 31.3002 8.97064 40 20 40C31.0294 40 40 31.3002 40 20.6039C40 9.90754 31.0294 1.20776 20 1.20776ZM20 38.8708C9.61525 38.8708 1.16436 30.6751 1.16436 20.6039C1.16436 10.5327 9.61525 2.33697 20 2.33697C30.3847 2.33697 38.8356 10.5294 38.8356 20.6039C38.8356 30.6783 30.3881 38.8708 20 38.8708Z",
    fill: "#002A67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 1.77075C9.29138 1.77075 0.583984 10.2185 0.583984 20.6039C0.583984 30.9893 9.29475 39.4371 20.0035 39.4371C30.7122 39.4371 39.4196 30.9893 39.4196 20.6039C39.4196 10.2185 30.7089 1.77075 20.0001 1.77075Z",
    fill: "url(#paint0_linear_4005_1223)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6771 25.7654C39.1598 24.1224 39.4196 22.3909 39.4196 20.6006C39.4196 18.8102 39.1598 17.0787 38.6771 15.4357V17.7628C33.7261 15.5404 4.90056 16.8627 1.29948 17.0362V16.3881H1.07335C0.752732 17.7432 0.583984 19.1506 0.583984 20.5973C0.583984 22.3549 0.833731 24.0536 1.29948 25.6672V18.3945C1.89009 20.4827 3.0882 24.4955 4.12769 26.6623H2.95658V29.6113C4.69468 32.6912 7.29678 35.2475 10.4389 36.9822V32.2854C11.826 33.1724 13.2806 33.9808 14.6036 34.5176V38.6875C16.318 39.1686 18.127 39.4272 20.0001 39.4272C21.8732 39.4272 23.6822 39.1686 25.3967 38.6875V33.0742C26.8074 32.5603 28.2181 32.0039 29.4871 31.4671V37.0215C32.6225 35.3129 35.2178 32.7861 36.9694 29.7389V26.6623H36.2337C37.1652 25.2385 38.073 23.4645 38.6771 21.7658V25.7589V25.7654Z",
    fill: "url(#paint1_linear_4005_1223)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 0C9.29138 0 0.583984 8.44775 0.583984 18.8332C0.583984 29.2186 9.29475 37.6663 20.0035 37.6663C30.7122 37.6663 39.4196 29.2186 39.4196 18.8332C39.4196 8.44775 30.7089 0 20.0001 0Z",
    fill: "url(#paint2_linear_4005_1223)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 5.14197C22.6966 5.14197 24.9309 3.23378 25.3595 0.736438C23.6551 0.261844 21.8597 0 20.0001 0C18.1405 0 16.345 0.258571 14.6406 0.736438C15.0692 3.23378 17.3001 5.14197 20.0001 5.14197Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 32.2723C17.2157 32.2723 14.9275 34.3016 14.6035 36.9201C16.318 37.4012 18.127 37.6663 20.0001 37.6663C21.8732 37.6663 23.6822 37.4045 25.3966 36.9201C25.076 34.3049 22.7844 32.2723 20.0001 32.2723Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88262 18.8331C5.88262 16.2179 3.91502 14.0512 1.33993 13.6355C0.850563 15.2884 0.580566 17.0297 0.580566 18.8331C0.580566 20.6366 0.847188 22.3778 1.33993 24.0307C3.91502 23.615 5.88262 21.4483 5.88262 18.8331Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1174 18.8331C34.1174 21.4516 36.085 23.615 38.6601 24.0307C39.1495 22.3778 39.4195 20.6366 39.4195 18.8331C39.4195 17.0297 39.1529 15.2884 38.6601 13.6355C36.085 14.0512 34.1174 16.2179 34.1174 18.8331Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8921 9.11552C31.8125 10.9779 34.8128 11.1514 36.939 9.64248C35.157 6.56581 32.5111 4.0161 29.3184 2.31738C27.7929 4.37941 27.9785 7.26297 29.8887 9.11552H29.8921Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.108 28.2988C8.15394 26.4037 5.08947 26.2564 2.95312 27.8471C4.71148 30.9598 7.3507 33.5389 10.5434 35.2737C12.214 33.2051 12.0723 30.2037 10.108 28.2988Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92575 9.11541C11.8123 7.28577 12.0182 4.44476 10.5535 2.38928C7.38778 4.10764 4.76881 6.65407 3.00708 9.73402C5.12655 11.1447 8.04252 10.9418 9.92575 9.11541Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8921 28.4789C27.965 30.3445 27.7929 33.2641 29.3589 35.3294C32.5516 33.6175 35.1942 31.0613 36.9694 27.9748C34.8398 26.443 31.8226 26.6067 29.8921 28.4821V28.4789Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 1.32881C30.5199 1.32881 39.1091 9.48526 39.4028 19.6219C39.4095 19.4419 39.4163 19.2651 39.4163 19.0851C39.4163 8.69973 30.7055 0.255249 20.0001 0.255249C9.29475 0.255249 0.583984 8.703 0.583984 19.0884C0.583984 19.2684 0.594109 19.4452 0.597484 19.6252C0.891106 9.48853 9.477 1.32881 20.0001 1.32881Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M20.0001 36.4782C9.49725 36.4782 0.92148 28.3479 0.597484 18.2407C0.590734 18.4371 0.583984 18.6335 0.583984 18.8331C0.583984 29.2185 9.29475 37.6663 20.0035 37.6663C30.7122 37.6663 39.4196 29.2185 39.4196 18.8331C39.4196 18.6335 39.4095 18.4371 39.4061 18.2407C39.0821 28.3512 30.5064 36.4782 20.0035 36.4782H20.0001Z",
    fill: "url(#paint3_linear_4005_1223)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 4.08154C11.8192 4.08154 5.1604 10.5393 5.1604 18.4732C5.1604 26.407 11.8158 32.8648 20.0001 32.8648C28.1844 32.8648 34.8364 26.4103 34.8364 18.4732C34.8364 10.536 28.181 4.08154 20.0001 4.08154Z",
    fill: "#003C93"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.973 4.08142C11.7921 4.08142 5.1333 10.5392 5.1333 18.473C5.1333 26.4069 11.7887 32.8647 19.973 32.8647C28.1573 32.8647 34.8093 26.4102 34.8093 18.473C34.8093 10.5359 28.1539 4.08142 19.973 4.08142Z",
    fill: "#003C93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9729 33.5029C11.4275 33.5029 4.4751 26.7605 4.4751 18.4731C4.4751 10.1857 11.4275 3.43994 19.9729 3.43994C28.5183 3.43994 35.4707 10.1824 35.4707 18.4698C35.4707 26.7572 28.5183 33.4997 19.9729 33.4997V33.5029ZM19.9729 4.71971C12.1565 4.71971 5.79471 10.8894 5.79471 18.4698C5.79471 26.0502 12.1565 32.2199 19.9729 32.2199C27.7893 32.2199 34.1511 26.0502 34.1511 18.4698C34.1511 10.8894 27.7893 4.71971 19.9729 4.71971Z",
    fill: "#003C93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.859 8.91899C17.749 8.14982 18.7345 6.17944 18.2789 4.30725C16.9424 4.46108 15.6059 4.78839 14.3032 5.31863C13.0004 5.84886 11.8226 6.54275 10.7729 7.35774C11.8293 8.98445 13.969 9.68488 15.859 8.91571V8.91899Z",
    fill: "url(#paint4_linear_4005_1223)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0701 27.916C22.1194 28.7081 21.1339 30.7832 21.6975 32.7045C23.0442 32.5539 24.3908 32.2233 25.7002 31.6898C27.0097 31.1563 28.1977 30.4592 29.2507 29.6311C28.2348 27.8898 26.0175 27.1206 24.0668 27.9127L24.0701 27.916Z",
    fill: "url(#paint5_linear_4005_1223)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1182 22.5253C9.32504 20.6956 7.29331 19.7366 5.36621 20.1785C5.52483 21.4746 5.86233 22.7707 6.40907 24.0341C6.95582 25.2975 7.67131 26.4398 8.51505 27.4578C10.1924 26.4333 10.9146 24.3582 10.1215 22.5253H10.1182Z",
    fill: "url(#paint6_linear_4005_1223)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8886 14.4866C30.6817 16.3195 32.7134 17.2752 34.6439 16.8333C34.4853 15.5372 34.1478 14.2411 33.601 12.9777C33.0543 11.7143 32.3388 10.572 31.4951 9.55408C29.8177 10.5785 29.0955 12.6569 29.8886 14.4866Z",
    fill: "url(#paint7_linear_4005_1223)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.986 8.88638C25.8962 9.64246 28.046 8.9093 29.0822 7.24986C26.9019 5.60351 24.2796 4.5725 21.529 4.29102C21.0835 6.16975 22.0892 8.13358 23.986 8.88966V8.88638Z",
    fill: "url(#paint8_linear_4005_1223)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9434 27.9519C14.0028 27.1828 11.8091 27.9519 10.7966 29.6703C12.9701 31.3494 15.5992 32.4033 18.3599 32.7077C18.9033 30.7831 17.8975 28.7244 15.9434 27.9487V27.9519Z",
    fill: "url(#paint9_linear_4005_1223)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0068 14.5684C10.7729 12.7486 10.0608 10.703 8.41045 9.68176C6.71285 11.7863 5.64974 14.3164 5.34937 16.9709C7.25959 17.3571 9.24069 16.3817 10.0068 14.5684Z",
    fill: "url(#paint10_linear_4005_1223)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8481 22.4434C29.0651 24.2992 29.8278 26.3907 31.549 27.3922C33.2669 25.2844 34.3435 22.7412 34.6506 20.0737C32.6965 19.6089 30.6344 20.581 29.8481 22.4434Z",
    fill: "url(#paint11_linear_4005_1223)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9527 6.24951C13.0036 6.24951 7.35059 11.7352 7.35059 18.4744C7.35059 25.2136 13.0036 30.6992 19.9527 30.6992C26.9017 30.6992 32.5548 25.2169 32.5548 18.4744C32.5548 11.7319 26.9017 6.24951 19.9527 6.24951Z",
    fill: "url(#paint12_linear_4005_1223)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0472 30.6816C13.2635 30.6816 7.71844 25.4578 7.45519 18.9412C7.44844 19.1015 7.44507 19.2619 7.44507 19.4223C7.44507 26.1615 13.0981 31.6472 20.0472 31.6472C26.9962 31.6472 32.6493 26.1648 32.6493 19.4223C32.6493 19.2619 32.6459 19.1015 32.6391 18.9412C32.3759 25.4578 26.8308 30.6816 20.0472 30.6816Z",
    fill: "#003C93"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9527 6.87997C26.7903 6.87997 32.3725 12.1921 32.548 18.7841C32.548 18.6793 32.5548 18.5746 32.5548 18.4699C32.5548 11.7306 26.9017 6.245 19.9527 6.245C13.0036 6.245 7.35059 11.7306 7.35059 18.4699C7.35059 18.5779 7.35734 18.6826 7.35734 18.7873C7.52946 12.1954 13.1116 6.87997 19.9527 6.87997Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 4.94561C28.0323 4.94561 34.5898 11.171 34.8261 18.9019C34.8294 18.7579 34.8362 18.6139 34.8362 18.4699C34.8362 10.536 28.1808 4.07825 19.9999 4.07825C11.819 4.07825 5.16357 10.5393 5.16357 18.4699C5.16357 18.6139 5.17032 18.7579 5.1737 18.9019C5.40995 11.1677 11.9675 4.94561 19.9999 4.94561Z",
    fill: "#003C93"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9331 23.8673H26.0445L25.9331 23.8639V23.8673Z",
    fill: "url(#paint13_linear_4005_1223)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_4005_1223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7768 26.9636C19.7736 26.9636 17.7704 26.9692 15.7672 26.9598C15.4477 26.9598 15 27.095 15 26.5393C15 25.9836 15.4458 26.1301 15.7672 26.1151C16.1193 26.0982 16.5057 26.1601 16.4732 25.6213C16.456 25.3322 16.6378 25.2459 16.8941 25.2496C17.1792 25.2534 17.4337 25.1764 17.3897 24.8423C17.2825 24.0181 17.8087 24.0444 18.3922 24.0482C20.6824 24.0632 22.9726 24.0632 25.2608 24.0482C25.7812 24.0444 26.1486 24.1195 26.074 24.7484C26.0319 25.107 26.2232 25.2571 26.581 25.2496C26.7723 25.2459 27.0134 25.2646 27.0077 25.5068C26.9923 26.1995 27.4783 26.1132 27.9203 26.1094C28.2302 26.1075 28.4962 26.1395 28.4828 26.5506C28.4675 26.9655 28.1805 26.9636 27.8839 26.9636C25.8482 26.9636 23.8125 26.9636 21.7787 26.9636H21.7768Z",
    fill: "url(#paint14_linear_4005_1223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6729 17.9762C20.2054 16.5382 18.736 15.1002 17.2686 13.6622C17.9937 12.213 19.2603 11.2912 20.567 10.4108C22.0402 11.8544 23.5135 13.298 24.9867 14.7435C25.0173 15.0514 24.8853 15.2954 24.6518 15.4775C23.9305 16.0426 23.3317 16.7259 22.6908 17.3698C22.4191 17.6439 22.1512 18.0025 21.6729 17.9762Z",
    fill: "url(#paint15_linear_4005_1223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4152 16.7221C19.4439 17.1764 19.2449 17.3078 19.0957 17.4618C16.7099 19.9266 14.3125 22.3821 11.9458 24.8639C11.5708 25.2581 11.3279 25.3107 10.9835 24.8808C10.8094 24.6611 10.5951 24.464 10.3712 24.2913C9.91204 23.9402 9.91012 23.6549 10.354 23.2532C12.8795 20.9723 15.3821 18.6689 17.898 16.3767C18.0932 16.1984 18.2787 15.8511 18.6021 16.0444C18.9465 16.2509 19.2239 16.5588 19.4152 16.7221Z",
    fill: "url(#paint16_linear_4005_1223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5671 10.4107C19.2603 11.293 17.9937 12.2148 17.2686 13.6621C16.6009 13.6546 15.7705 14.1972 15.3802 13.2097C15.0416 12.3537 15.8547 12.0158 16.2967 11.5502C17.0734 10.7317 17.9076 9.96579 18.7093 9.16982C19.0919 8.79062 19.5148 8.5109 20.0524 8.80751C20.5728 9.09661 20.7928 9.54153 20.5384 10.1347C20.5058 10.2098 20.5556 10.3168 20.569 10.4088L20.5671 10.4107Z",
    fill: "url(#paint17_linear_4005_1223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6729 17.9761C22.1512 18.0024 22.4171 17.6438 22.6907 17.3697C23.3317 16.7239 23.9305 16.0425 24.6518 15.4774C24.8852 15.2953 25.0173 15.0513 24.9866 14.7434C25.6008 14.8241 26.3852 14.46 26.7315 15.2747C27.0951 16.1307 26.2991 16.4837 25.8476 16.953C25.0632 17.7677 24.2347 18.5393 23.4292 19.3352C23.037 19.7238 22.662 20.0955 22.0383 19.7201C21.4509 19.3672 21.4586 18.896 21.6633 18.3478C21.7035 18.237 21.6729 18.1019 21.6748 17.978L21.6729 17.9761Z",
    fill: "url(#paint18_linear_4005_1223)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_4005_1223",
    x: 10,
    y: 8.57849,
    width: 18.75,
    height: 20.259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.923077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.235294 0 0 0 0 0.576471 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4005_1223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4005_1223",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.923077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4005_1223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4005_1223",
    x1: 20.2465,
    y1: 36.7368,
    x2: 20.1132,
    y2: 27.4117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#033B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5298FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4005_1223",
    x1: 0.583984,
    y1: 27.438,
    x2: 39.4163,
    y2: 27.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4005_1223",
    x1: 28.9775,
    y1: 49.1973,
    x2: 13.3532,
    y2: -6.99308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01327A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4005_1223",
    x1: 0.583984,
    y1: 27.9519,
    x2: 39.4196,
    y2: 27.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4005_1223",
    x1: 10.7729,
    y1: 6.77186,
    x2: 18.3869,
    y2: 6.77186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4005_1223",
    x1: 21.5423,
    y1: 30.1548,
    x2: 29.2541,
    y2: 30.1548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4005_1223",
    x1: 5.36284,
    y1: 23.7658,
    x2: 10.4388,
    y2: 23.7658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4005_1223",
    x1: 29.5646,
    y1: 13.2461,
    x2: 34.6405,
    y2: 13.2461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4005_1223",
    x1: 21.4244,
    y1: 6.73599,
    x2: 29.0822,
    y2: 6.73599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4005_1223",
    x1: 10.8,
    y1: 30.1809,
    x2: 18.505,
    y2: 30.1809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4005_1223",
    x1: 5.34937,
    y1: 13.3672,
    x2: 10.3139,
    y2: 13.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4005_1223",
    x1: 29.5409,
    y1: 23.674,
    x2: 34.6506,
    y2: 23.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4005_1223",
    x1: 24.843,
    y1: 34.9018,
    x2: 17.362,
    y2: 8.18273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034AB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4005_1223",
    x1: 25.9331,
    y1: 23.8639,
    x2: 26.0445,
    y2: 23.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4005_1223",
    x1: 21.7416,
    y1: 24.3227,
    x2: 21.7416,
    y2: 26.7268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3DABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4005_1223",
    x1: 21.1298,
    y1: 11.123,
    x2: 21.1298,
    y2: 17.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3DABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4005_1223",
    x1: 14.721,
    y1: 16.8529,
    x2: 14.721,
    y2: 24.4044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3DABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4005_1223",
    x1: 17.9721,
    y1: 9.16522,
    x2: 17.9721,
    y2: 13.3711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3DABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4005_1223",
    x1: 24.1805,
    y1: 15.2142,
    x2: 24.1805,
    y2: 19.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3DABFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptCoin);
export default __webpack_public_path__ + "static/media/attempt-coin.8284fca7ffa6a18c2ca6247a597bd7da.svg";
export { ForwardRef as ReactComponent };